import type { ComplianceExclusionReason } from '@deepguide-ai/types'

/** Human labels for the compliance-duty exclusion reasons. Shared by the Edit
 *  dialog form and the People-table bulk header + badge so they never drift. */
export const EXCLUSION_REASON_OPTIONS: {
  value: ComplianceExclusionReason
  label: string
}[] = [
  { value: 'SERVICE_ACCOUNT', label: 'Service account' },
  { value: 'TEST_ACCOUNT', label: 'Test account' },
  { value: 'SHARED_ACCOUNT', label: 'Shared / system account' },
  { value: 'EXTERNAL', label: 'External (non-workforce)' },
  { value: 'OTHER', label: 'Other' },
]

export const EXCLUSION_REASON_LABEL = Object.fromEntries(
  EXCLUSION_REASON_OPTIONS.map((o) => [o.value, o.label]),
) as Record<ComplianceExclusionReason, string>
